import defaultTo from 'lodash-es/defaultTo';
import forIn from 'lodash-es/forIn';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import mapValues from 'lodash-es/mapValues';
import {
  TweenMax,
  Power0,
  Power1,
  Power2,
  Power3,
  Power4,
  Back,
  Elastic,
  Bounce,
  Circ,
  Expo,
  Sine,
} from 'gsap';

const EASING_CLASSES = {
  Power0,
  Power1,
  Power2,
  Power3,
  Power4,
  Back,
  Elastic,
  Bounce,
  Circ,
  Expo,
  Sine,
};

const DEFAULT_EASING_CLASS = Power3;
const DEFAULT_EASING_CURVE = 'easeOut';

export const TRANSITION_PHASE_ENTER = 'enter';
export const TRANSITION_PHASE_EXIT = 'exit';

const mapReplace = (object, replaceMap) =>
  object && replaceMap
    ? mapValues(object, value => {
        let finalValue = value;
        forIn(replaceMap, (replaceValue, replaceKey) => {
          if (isString(finalValue)) {
            finalValue = finalValue.replace(`%%${replaceKey}%%`, replaceValue);
          }
        });
        return finalValue;
      })
    : object;

export const removeStyles = (element, props = 'all') => {
  TweenMax.set(element, { clearProps: props });
};

export const getTransitionFromTransitionConfig = (
  config,
  phase,
  replaceMap,
) => {
  if (!config || config.duration === 0) {
    return null;
  }

  const { duration, ease } = config;
  const fromParams = mapReplace(config[phase].from, replaceMap);
  const toParams = mapReplace(config[phase].to, replaceMap);

  return {
    duration,
    ease,
    fromParams,
    toParams,
  };
};

export const stopAllElementTransitions = element => {
  TweenMax.killTweensOf(element);
};

export const reverse = () => {
  if (window.transition) {
    window.transition.reverse(null, false);
  }
};

export const runTransition = ({ element, transition, onStart, onComplete }) => {
  const { duration, ease, fromParams, toParams } = transition;

  const easingClass = defaultTo(
    EASING_CLASSES[ease.type],
    DEFAULT_EASING_CLASS,
  );
  const easingFunc = easingClass[defaultTo(ease.curve, DEFAULT_EASING_CURVE)];

  if (isFunction(onStart)) {
    onStart();
  }
  removeStyles(element, 'transform');
  window.transition = TweenMax.fromTo(element, duration / 1000, fromParams, {
    ...toParams,
    ease: easingFunc,
    onInterrupt: () => {
      removeStyles(element);
    },
    onComplete: () => {
      if (isFunction(onComplete)) {
        onComplete();
        removeStyles(element, 'opacity,scale,transform');
      }
    },
  });
};
